export class ReimbursementClaimDTORevert {
  /** @minLength 1 */
  status: string = '';

  constructor(obj?: ReimbursementClaimDTORevert) {
    Object.assign(this, obj)
  }
}
